<template>
  <div>
    <div class="basicBox">
      <div class="stuMes">
        <div class="avaImg">
          <img src="../../../../assets/avatar.png" alt="" />
        </div>
        <div class="sName">
          <div>{{ sMes.name }}</div>
          <div>{{ sMes.classname }}</div>
        </div>
      </div>

      <div class="basicBottom">
        <div>参与课程详情：</div>
        <div class="courseDetail">
          <div class="courseChild">
            <div>{{ sMes.allCourseNum }}</div>
            <div>课程总数</div>
          </div>
          <div class="courseChild">
            <div>{{ sMes.isFinishTaskWorks }}</div>
            <div>已学习</div>
          </div>
          <div class="courseChild">
            <div>{{ sMes.noFinishTaskWorks }}</div>
            <div>待学习</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["sMes"],
  data() {
    return {};
  },
};
</script>

<style scoped>
.basicBox {
  margin: 20px 0;
}
.basicBottom {
  margin-left: 20px;
}
.basicBottom > div:first-child {
  margin: 20px 0;
}
.stuMes {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin-left: 20px;
}
.avaImg {
  width: 50px;
  height: 49px;
}

.avaImg > img {
  width: 100%;
  height: 100%;
}
.sName {
  margin-left: 5px;
}
.sName > div:last-child {
  color: #d2d2d2;
  font-size: 14px;
  margin-top: 5px;
}
.courseDetail {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 5px;
  width: 90%;
  justify-content: space-around;
}
.courseChild {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
}
.courseChild > div:first-child {
  color: #3868c1;
  font-size: 32px;
  font-weight: bold;
}
.courseChild > div:last-child {
  background: #e1edff;
  border: 1px solid #c8deff;
  border-radius: 5px;
  color: #3b86ff;
  padding: 1px 3px;
  min-width: 75px;
  height: 25px;
  line-height: 25px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/myReport/components/mrBasicData.vue